// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Aly2"};


//////////////////
// WEBPACK FOOTER
// ./app/components/notification-list/notification-list.scss
// module id = 1666
// module chunks = 0